import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect  } from "react";
//import pieces from "./pieces.json" with { type: 'json'};
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';


var pieces = require("./pieces.json");

function Content(props)
{
    const [selectedPiece, selectPiece] = useState(undefined);
    useEffect(() => {
        document.addEventListener("contextmenu", function (e){
            e.preventDefault();
            }, false);
    }, []);

    const select = (id) => {
        if (selectedPiece !== undefined)
            return;
        console.log("Select piece " + id);
        selectPiece(id);
    }

    const closePiece = () => {
        console.log("Close Piece")
        selectPiece(undefined);
    }

    const showThumbnail = (entry, index) => {
        const filePath = process.env.PUBLIC_URL + entry.thumbnail
        return (<img id="thumbnail" src={filePath} onClick={() => select(index)} alt={filePath}/>);
    }

    const prev = () => {
        var index = selectedPiece - 1;
        if (index < 0)
            index = pieces.length - 1;
        selectPiece(index);
    }

    const next = () => {
        var index = selectedPiece + 1;
        if (index >= pieces.length)
            index = 0;
        selectPiece(index);
    }

    const showPiece = () => {
        if (selectedPiece === undefined)
            return (<div/>);

        return (<img id="pieceImage" src={process.env.PUBLIC_URL + "/" + pieces[selectedPiece].piece} alt="piece01"/>);
    }

    const showDescription = () => {
        if (selectedPiece === undefined)
            return (<div/>);

        return (pieces[selectedPiece].description.map((entry) => {return (<dt> {entry} </dt>)}));
    }

    return(
        <div id="content" className="content">
            <div id="piece" hidden={selectedPiece == undefined} >
                <div id="piece-frame">
                    <div id="piece-frame-in">
                        <div id="prev" onClick={() => {prev();}}>
                        <NavigateBeforeIcon fontSize="large" sx={{color: "#c0c0c0"}}/>
                        </div>
                        {showPiece()}
                        <div id="next" onClick={() => {next();}}>
                        <NavigateNextIcon fontSize="large" sx={{color: "#c0c0c0"}}/>
                        </div>
                    </div>
                    <div id="description">
                        <dl>
                        {showDescription()}
                        </dl>
                    </div>
                </div>
                <div onClick={closePiece}>
                    <CloseIcon id="closeIcon" fontSize="medium" sx={{ color: "#c0c0c0"}}/>
                </div>
            </div>
            <div id="thumbnail_body" hidden={selectedPiece !== undefined}>
                <div id="thumbnails">
                    {pieces.map((entry, index) => {return showThumbnail(entry, index)})}
                </div>
                <div id="copyright">  &#169; 2024-2025 Mi Young Kim</div>
            </div>
        </div>
    )
}
export default Content;
